const EVENT_OFFER = 'event-offer';

const offerEventTrigger = () => {
  const form = document.querySelector('#make-offer-form');
  if (form) {
    form.addEventListener('submit', () => {
      const event = new CustomEvent(EVENT_OFFER);
      document.dispatchEvent(event);
    });
  }
};

export {EVENT_OFFER, offerEventTrigger};